// Keep captions clear of the native bottom playback controls. The cue line
// is a percentage of the *video* height, not the document/window. Browsers
// may otherwise move default-positioned cues when player controls appear.
// Only used for self-guided WonderLabs video. Normal AI Tutor is unchanged.
export function placeWonderLabsCaptionCues(textTrack) {
  const cues = textTrack?.cues;
  if (!cues?.length) return 0;
  let positioned = 0;
  for (let i = 0; i < cues.length; i += 1) {
    const cue = cues[i];
    try {
      if ("snapToLines" in cue) cue.snapToLines = false;
      if ("line" in cue) cue.line = 72;
      if ("lineAlign" in cue) cue.lineAlign = "start";
      if ("position" in cue) cue.position = 50;
      if ("size" in cue) cue.size = 90;
      if ("align" in cue) cue.align = "center";
      positioned += 1;
    } catch (e) {
      // An engine may expose read-only cues. Native captions still work.
    }
  }
  return positioned;
}
